import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useQuery } from "@redux-requests/react";
import { Typography } from "@material-ui/core";
import * as types from "../../ducks/types";
import { getEPosters } from "../../ducks/actions";
import EPostersGrid from "../../components/EPostersGrid";

const EPostersTab = ({ profileId }) => {
  const intl = useIntl();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEPosters({ profileId }));
  }, [dispatch, profileId]);

  const {
    data: { data: ePosters },
    loading: ePostersLoading
  } = useQuery({ type: types.GET_EPOSTERS, defaultData: { data: [] } });

  return (
    <>
      <Typography variant="h5">
        {intl.formatMessage({
          id: "Experts.EPostersTab.EPoster",
          defaultMessage: "e-Posters"
        })}
      </Typography>
      <EPostersGrid ePosters={ePosters} loading={ePostersLoading} truncateWords />
    </>
  );
};

export default EPostersTab;
